import styled from 'styled-components';
import { topbarHeight } from '@styles/layout';
import { black, violet } from '@styles/colors';
import { ctaBorderSize, ctaFixVerticalAlign, Cta } from '@components/Cta/Cta.s';
import { Link, LinkProps } from '@components/Link/Link';

export const MenuWrapper = styled.nav`
  height: ${topbarHeight}px;
  display: flex;
  flex-direction: row;
  justify-content: right;
  align-items: center;
`;

type MenuItemProps = LinkProps & { isActive?: boolean };

export const MenuItem = styled(Link)`
  line-height: ${(topbarHeight * 0.6) + (ctaBorderSize * 2) + ctaFixVerticalAlign}px;
  vertical-align: middle;
  color: ${black};
  font-size: 1rem;
  cursor: pointer;
  padding: 0 1rem;
  text-decoration: none;
  margin-right: 1rem;
  transition-duration: .3s;
  position: relative;
  &:after {
    content: '';
    display: block;
    position: absolute;
    background: ${violet};
    left: 1rem;
    right: 1rem;
    height: 3px;
    bottom: ${(props: MenuItemProps) => props.isActive ? 2 : -10}px;
    opacity: ${(props: MenuItemProps) => props.isActive ? 1 : 0};
    transition-duration: .3s;
  }
  &:hover:after {
    bottom: 2px;
    opacity: 1;
  }
`;

export const MenuItemCta = Cta.extend`
  margin-left: 1rem;
`;


// WEBPACK FOOTER //
// src/app/src/components/Menu/Menu.s.ts